import {AppDispatch} from 'store';
import {apiQuery} from 'helpers/query';
import {DigestsActionTypes, DigestsAction} from 'store/types/digestsActionTypes';
import { bulkCreateDigestTemplate, createDigestTemplate, deleteDigestTemplate, getDigestsQuery, getDigestTemplateCategories, getDigestTemplates, ICreateDigestTemplateParams, searchDigestsQuery } from 'api/digests';
import { IGetDigestsTemplatesParams } from 'api/types';


export interface IGetDigestsDataParams {
    searchParams: string | null,
    limit: string | null,
    sort: string | null,
    dateFrom: Date | null,
    dateTo: Date | null,
    page: string | null,
}


export interface ISearchDigestsParams {
    searchParams: string | null,
}



export const getDigestsData = ({searchParams, sort, page, dateFrom, dateTo, limit}: IGetDigestsDataParams) => {
    return async (dispatch: AppDispatch) => {
        try {
            const {digests, dist} = await apiQuery(() => getDigestsQuery({
                searchParams,
                page,
                sort,
                limit,
                dateFrom,
                dateTo
            }));

            dispatch({
                type: DigestsActionTypes.FETCHING_DIGESTS,
                payload: {digests, dist},
            });
        } catch (error) {
            if (error instanceof Error) {
                dispatch({
                    type: DigestsActionTypes.FETCH_ERROR,
                    payload: error.message,
                });
            }
        }
    };
};



export const searchDigestsData = ({searchParams}: ISearchDigestsParams) => {
    return async (dispatch: AppDispatch) => {
        try {
            const {digests: searchResult} = await apiQuery(() => searchDigestsQuery({
                searchParams,
            }));

            dispatch({
                type: DigestsActionTypes.SEARCHING_DIGESTS,
                payload: {searchResult},
            });
        } catch (error) {
            if (error instanceof Error) {
                dispatch({
                    type: DigestsActionTypes.FETCH_ERROR,
                    payload: error.message,
                });
            }
        }
    };
};

export const getTemplateCategoryDefaults = ( ) => {
    return async (dispatch: AppDispatch) => {
        try {
            const categories = await apiQuery(() => getDigestTemplateCategories());

            dispatch({
                type: DigestsActionTypes.FETCHING_DIGEST_TEMPLATES_CATEGORY,
                payload: categories,
            });
        } catch (error) {
            if (error instanceof Error) {
                dispatch({
                    type: DigestsActionTypes.FETCH_ERROR,
                    payload: error.message,
                });
            }
        }
    };
};

export const getTemplates = ( {searchParams, sort, page, dateFrom, dateTo, limit}: IGetDigestsTemplatesParams) => {
    return async (dispatch: AppDispatch) => {
        try {
            const {templates, dist} = await apiQuery(() => getDigestTemplates({
                searchParams,
                page,
                sort,
                limit,
                dateFrom,
                dateTo
            }));

            dispatch({
                type: DigestsActionTypes.FETCHING_DIGEST_TEMPLATES,
                payload: {templates , dist},
            });
        } catch (error) {
            if (error instanceof Error) {
                dispatch({
                    type: DigestsActionTypes.FETCH_ERROR,
                    payload: error.message,
                });
            }
        }
    };
};

export const uploadBulkTemplates = ( fileURL: string) => {
 return async (dispatch: AppDispatch) => {
         try {
             const resp = await apiQuery(() => bulkCreateDigestTemplate(fileURL));
             return resp
             
         } catch (error) {
             if (error instanceof Error) {
                dispatch({
                    type: DigestsActionTypes.FETCH_ERROR,
                    payload: error.message,
                });
             }
         }
     };
};

export const deleteDigestTemplates = ( templateId: string) => {
    return async (dispatch: AppDispatch) => {
            try {
                const resp = await apiQuery(() => deleteDigestTemplate(templateId));
                return resp
                
            } catch (error) {
                if (error instanceof Error) {
                   dispatch({
                       type: DigestsActionTypes.FETCH_ERROR,
                       payload: error.message,
                   });
                }
            }
        };
   };
   

export const createTemplate= (data: ICreateDigestTemplateParams) => {
    return async (dispatch: AppDispatch) => {
        try {
            const createdTemplate = await apiQuery(() => createDigestTemplate(data));

            dispatch({
                type: DigestsActionTypes.CREATING_DIGEST_TEMPLATE,
                payload: createdTemplate,
            });
        } catch (error) {
            if (error instanceof Error) {
                dispatch({
                    type: DigestsActionTypes.FETCH_ERROR,
                    payload: error.message,
                });
            }
        }
    };
};

